import { useMemo } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getMaterialsPath } from "@repo/structure";
import { useEstimateStructure } from "@tools";
import { ColumnFactory, RowContainer } from "./components";

export const MaterialsRow = observer(() => {
  const {t} = useTranslation();
  
  const structure = useEstimateStructure();
  const { turnOffMaterials } = structure;
  const { materialsTitle } = structure.settings;
  const { hideSummaryMaterials } = structure.visibility;
  
  const handleTurnOff = () =>
    structure.setTurnOffMaterialsState(!turnOffMaterials);
  const handleVisibility = () =>
    structure.visibility.setHideSummaryMaterials(!hideSummaryMaterials);
  const handleNameChange = (value) =>
    structure.settings.setMaterialsTitle(value);
  
  const commentPath = useMemo(() => getMaterialsPath(), []);
  const title = useMemo(() => (
    materialsTitle || t("views.editor.summary_table.materials")
  ), [materialsTitle]);
  
  return (
    <RowContainer
      title={title}
      inputPlaceholder={t("views.editor.summary_table.materials")}
      commentPath={commentPath}
      onTurnOffChange={handleTurnOff}
      onVisibilityChange={handleVisibility}
      onNameChange={handleNameChange}
      turnOff={turnOffMaterials}
      isHidden={hideSummaryMaterials}
    >
      <ColumnFactory type="materials" />
    </RowContainer>
  );
});